import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  TextField,
  Button,
  CircularProgress,
  Paper,
  Stack,
  Alert,
} from "@mui/material";

import LockResetIcon from "@mui/icons-material/LockReset";

import api from "../services/api.service";

/* ================= COMPONENT ================= */
// Pantalla forzosa: se muestra cuando el backend marca debeCambiarPassword = true
// (ver auth.middleware.js `requirePasswordOk`). Mientras no se envíe una contraseña
// nueva, ninguna otra ruta del sistema responde (403 MUST_CHANGE_PASSWORD).
const CambiarPasswordObligatorioPage = () => {
  const navigate = useNavigate();

  const [passwordNueva, setPasswordNueva] = useState("");
  const [confirmar, setConfirmar] = useState("");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async () => {
    setError("");

    if (passwordNueva.length < 8) {
      setError("La nueva contraseña debe tener al menos 8 caracteres");
      return;
    }
    if (passwordNueva !== confirmar) {
      setError("Las contraseñas no coinciden");
      return;
    }

    setLoading(true);
    try {
      await api.post("/auth/cambiar-password-obligatorio", { passwordNueva });
      navigate("/", { replace: true });
    } catch (err: any) {
      setError(err.response?.data?.message || "Error al actualizar la contraseña");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      sx={{
        background: "linear-gradient(135deg, #0f172a, #1e293b)",
      }}
    >
      <Paper
        elevation={8}
        sx={{
          p: 5,
          width: 440,
          borderRadius: 3,
          backdropFilter: "blur(8px)",
          background: "rgba(255,255,255,0.97)",
        }}
      >
        <Stack spacing={3}>
          <Box textAlign="center">
            <Box display="flex" justifyContent="center" gap={1} mb={1}>
              <LockResetIcon sx={{ color: "#0f172a" }} />
            </Box>
            <Typography variant="h5" fontWeight={700}>
              Genera una nueva contraseña
            </Typography>
            <Typography variant="body2" color="text.secondary" mt={1}>
              Por seguridad debes elegir una contraseña propia, que nadie más
              conozca, antes de continuar.
            </Typography>
          </Box>

          {error && <Alert severity="error">{error}</Alert>}

          <TextField
            label="Nueva contraseña"
            type="password"
            value={passwordNueva}
            onChange={(e) => setPasswordNueva(e.target.value)}
            helperText="Mínimo 8 caracteres"
            fullWidth
          />

          <TextField
            label="Confirmar nueva contraseña"
            type="password"
            value={confirmar}
            onChange={(e) => setConfirmar(e.target.value)}
            fullWidth
          />

          <Button
            variant="contained"
            startIcon={<LockResetIcon />}
            onClick={handleSubmit}
            disabled={loading}
            fullWidth
            sx={{
              py: 1.5,
              fontWeight: 600,
              background: "#0f172a",
              "&:hover": {
                background: "#020617",
              },
            }}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Guardar y continuar"
            )}
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
};

export default CambiarPasswordObligatorioPage;
